import * as Yup from "yup";

export const shippingValidation = Yup.object().shape({
  name: Yup.string().required("وارد کردن نام الزامی است"),
  price: Yup.string().required("وارد کردن نام الزامی است"),
});
